<template>
  <div class="syotei-work-week-times edit-item" v-if="editingData && options">

    <div class="head"><b>所定労働時間（週）</b></div>
    <div class="data flex flex-align-center">
      <div class="hours">
        <input-text v-model="editingData.syotei_work_week_times_hours" :type="'number'" inputmode="numeric" class="small" min="0"
          :error="getError(editingData, 'syotei_work_week_times_hours')" :disabled="disabled"></input-text>
        <p class="current-data">{{ currentData?.syotei_work_week_times_hours }}</p>
      </div>
      <p class="scale">時間</p>

      <div class="minutes">
        <select-box :options="options?.minutes_in_hour_round" v-model="editingData.syotei_work_week_times_minutes"
          class="small" :error="getError(editingData, 'syotei_work_week_times_minutes')" :disabled="disabled"></select-box>
        <p class="current-data">{{ currentData?.syotei_work_week_times_minutes }}</p>
      </div>
      <p class="scale">分</p>
    </div>
  </div>
</template>

<script lang="ts">
import { useForm } from '@/composable/form/form';
import { KoyouKeiyakuOption } from '@/types/KoyouKeiyaku';
import { KoyouKeiyakuDetail } from '@/types/KoyouKeiyakuDetail';
import { defineComponent } from 'vue';

export default defineComponent({
  props: {
    editingData: {
      type: Object as () => KoyouKeiyakuDetail | null,
      require: true,
      default: []
    },
    currentData: {
      type: Object as () => KoyouKeiyakuDetail | null,
      require: true,
      default: []
    },
    options: {
      type: Object as () => KoyouKeiyakuOption | null,
      require: true,
      default: null
    },
    disabled: {
      type: Object as () => boolean,
      default: false
    }
  },
  setup() {
    const { getError } = useForm();

    return {
      getError,
    }
  }
})
</script>

<style lang="scss" scoped>
@import '@scss/components/koyoukeiyaku.scss';
@import '@scss/components/koyoukeiyaku-edit.scss';

</style>
